<template>
    <div id="post-audio-player" v-if="content">
        <div class="title-box-container">
            <span>محتوای صوتی ({{content.file_type}})</span>
            <span v-if="content.file_title">
            فهرست
               <div class="more-details-text-content">
                   {{content.file_title}}
               </div>
            </span>
        </div>
        <div class="audio-box-container">
            <audio controls>
                <source :src="$store.state.base_urls.postsUploads+content.file_name" type="audio/ogg">
                <source :src="$store.state.base_urls.postsUploads+content.file_name" type="audio/mpeg">
            </audio>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PostAudioPlayer",
        props:['content'],
    }
</script>

<style lang="scss" scoped>
    #post-audio-player{
        width: 100%;
        height: 120px;
        border-radius: 10px;
        border: 2px solid rgba(232,232,232,0.5);
        padding: 15px 10px 0 10px;
        margin: 20px 0;
        .title-box-container{
            height: 20px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 0px solid rgba(151, 151, 151, 1);
            font-family: 'IRANSans';
            font-size: 17px;
            color: rgba(26, 26, 26, 1);
            text-align: right;
            line-height: 12px;
            span{
                &:nth-child(2){
                    text-decoration: underline;
                    cursor: pointer;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:hover{
                        .more-details-text-content{
                            display: block;
                        }
                    }
                }
            }
        }
        .more-details-text-content{
            transition: all 0.1s;
            display: none;
            height: auto;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.92;
            letter-spacing: normal;
            text-align: justify;
            color: #162336;
            width: 300px;
            position: absolute;
            bottom: 30px;
            border-radius: 10px;
            padding: 10px;
            border: 2px solid rgba(208,208,208,0.5);
            background-color: white;
            z-index: 1;
            left: -10px;
        }
        .more-details-text-content:before{
            content: "";
            position: absolute;
            top: 110%;
            margin-top: -7px;
            left: 10%;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;

            border-top: 10px solid rgba(208,208,208,0.5);
        }
        .audio-box-container{
            height: calc(100% - 20px);
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            audio{
                border-radius: 10px;
                width: 100%;
                margin: 0;
                padding: 0;
            }
        }
    }
    audio:focus{
        border: none!important;
        outline: 0;
    }
</style>